/* eslint-disable */
import React from 'react'
import {APP} from '../BaseComponent/configTheme'
import {Link} from 'react-router-dom'

import moment from 'moment'
import jMoment from 'moment-jalaali'
import {Checkbox, Icon, message} from 'antd'
import $ from 'jquery'
import http from '../../Component/Interceptor/Interseptor'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import cookie from 'react-cookies'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import RETAIL from '../BaseComponent/RETAIL'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import Select from 'react-select'
import Loader from '../loaders/loader'
import AutoComplete from '../BaseComponent/autocomplete'
import {ExcelExport, grid, gridColumn} from '@progress/kendo-react-excel-export'
import {editOrder} from '../../lib/path'

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})

class Search extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDate: null,
      allPlans: [],
      errorPlans: '',
      today: moment(),
      AssignedDrivers: [],
      planDateMin: '',
      planDateMax: '',
      convertPrint: '',
      finalPrintTime: '',
      productModal: false,
      products: [],
      modalConfirm: false,
      modalText: '',
      lacksProduct: [],
      showProduct: false,
      showLacks: false,
      shift: [],
      modalConfirmFinaly: false,
      dayPartId: 3,
      aggregationAssigned: {},
      aggregationPlan: {},
      aggregationGeoAll: {},
      geoAll: [],
      provider: [],
      selectedOption: '',
      unclosedParcels: [],
      loading: false,
      excelExport: [],
      excelDayPartId: 3,
      providerId: '',
      unmatchProductDetailItems: [],
      unmatchProductDetailItemsModal: false
    }
    this.cancelBtn = React.createRef()
  }

  componentDidMount() {
    // http
    //   .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
    //   .then((response) => {
    //     if (response.data.error == null) {
    //       var provider = response.data.object;
    //       for (let i = 0; i < provider.length; i++) {
    //         provider[i]["value"] = provider[i].providerId;
    //         provider[i]["label"] =
    //           provider[i].providerId + " - " + provider[i].title;
    //       }

    //       this.setState({
    //         providers: response.data.object,
    //       });
    //     } else {
    //       this.setState({
    //         providers: [],
    //       });
    //     }
    //   });

    http.get(`public/base/type/dayParts`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          shift: response.data.object
        })
      } else {
        this.setState({
          shift: []
        })
        message.error(response.data.error)
      }
    })
    if (sessionStorage.getItem('planParams')) {
      var params = sessionStorage.getItem('planParams')

      var planTime = sessionStorage.getItem('planTime')

      var objectPlanTime = JSON.parse(planTime)

      // finalPrintTime
      this.setState({
        finalPrintTime: jMoment(objectPlanTime.planDateMin).format('jYYYY/jMM/jDD')
      })
      this.driverAll(params, 3)
      this.planAll(params, 3)
      this.geoAll(params, 3)
    } else {
      const myDate = moment(this.state.today).format('YYYY/MM/DD')

      const jalaliMyDate = jMoment(this.convertDigit(myDate), 'YYYY/MM/DD').format('jYYYY/jM/jD')

      sessionStorage.setItem('selectDate', jalaliMyDate)
      const listData = {
        planDateMin: this.epochFrom(this.state.today),
        planDateMax: this.epochTo(this.state.today)
      }

      this.setState({
        planDateMin: this.epochFrom(this.state.today),
        planDateMax: this.epochTo(this.state.today),
        finalPrintTime: jMoment(this.epochFrom(this.state.today)).format('jYYYY/jMM/jDD')
      })

      sessionStorage.setItem('planTime', JSON.stringify(listData))
      this.driverAll(`planDateMin=${listData.planDateMin}&planDateMax=${listData.planDateMax}&sortBy=lastName_asc`, 3)
      this.planAll(
        `planDateMin=${listData.planDateMin}&planDateMax=${
          listData.planDateMax
        }&sortBy=deliveryPlanDate_desc,deliveryPlanTimeFrom_asc`,
        3
      )
      this.geoAll(`planDateMin=${listData.planDateMin}&planDateMax=${listData.planDateMax}`, 3)
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  driverAll = (params, dayPartId) => {
    var planTime = sessionStorage.getItem('planTime')

    var objectPlanTime = JSON.parse(planTime)
    this.setState({
      finalPrintTime: jMoment(objectPlanTime.planDateMin).format('jYYYY/jMM/jDD')
    })

    return http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_ALL}?export=true&${params}&dayPartId=${dayPartId}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          this.setState({
            planDateMin: objectPlanTime.planDateMin,
            planDateMax: objectPlanTime.planDateMax
          })

          this.setState({
            AssignedDrivers: response.data.object.result,
            aggregationAssigned: response.data.object.aggregation
          })
          return response.data.object
        } else {
          this.setState({
            AssignedDrivers: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  planAll = (params, dayPartId) => {
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_PLAN_ALL}?${params}&dayPartId=${dayPartId}`, {})
      .then((response) => {
        if (response.data.error == null) {
          // alert(JSON.stringify(response))

          this.setState({
            allPlans: response.data.object.result,
            errorPlans: '',
            aggregationPlan: response.data.object.aggregation
          })
        } else if (response.data.error == 'EMPTY_RESULTS') {
          this.setState({
            errorPlans: JSON.stringify('خطای ' + response.data.errorCode + ' : ' + response.data.description),
            allPlans: []
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  geoAll = (params, dayPartId) => {
    // http.get(`${REPORT_DISPATCH.REPORT_DISPATCH_GEO_ALL}?${params}&dayPartId=${dayPartId}&sortBy=deliveryGeoSortOrder_desc`, {}).then((response) => {
    //     if (response.data.error == null) {
    //         // alert(JSON.stringify(response))
    //
    //         this.setState({
    //             geoAll: response.data.object.result
    //             ,
    //             errorPlans: ''
    //             ,
    //             aggregationGeoAll:response.data.object.aggregation
    //         })
    //     } else if (response.data.error == 'EMPTY_RESULTS') {
    //         this.setState({
    //             geoAll: []
    //         })
    //     }
    //
    // }).catch((error) => {
    //     console.log(error)
    // })
  }

  epochFrom = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    // alert(concatDate)
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  epochTo = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()

    if (n >= 0) {
      return toEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return toEpoch - 3.5 * 3600 * 1000
    } else {
      return toEpoch - 3.5 * 3600 * 1000
    }
    // return toEpoch - (3.5 * 3600 * 1000);
  }

  handleDateChange = (date) => {
    this.setState({
      selectedDate: date,
      convertPrint: jMoment(date).format('jYYYY/jMM/jDD')
    })
  }

  searchPlanList() {
    if (this.state.selectedDate == null) {
      $('#date').addClass('errorInput')
      this.setState({
        errorPlans: 'یک تاریخ وارد کنید'
      })
    } else {
      this.setState({
        errorPlans: ''
      })
      $('#date').removeClass('errorInput')

      var myDate = moment(this.state.selectedDate).format('YYYY/MM/DD')

      const jalaliMyDate = jMoment(this.convertDigit(myDate), 'YYYY/MM/DD').format('jYYYY/jM/jD')

      sessionStorage.setItem('selectDate', jalaliMyDate)

      const token = sessionStorage.getItem('accessToken')
      const listData = {
        planDateMin: this.epochFrom(this.state.selectedDate),
        planDateMax: this.epochTo(this.state.selectedDate)
      }

      sessionStorage.setItem('planTime', JSON.stringify(listData))

      this.setState({
        planDateMin: this.epochFrom(this.state.selectedDate),
        planDateMax: this.epochTo(this.state.selectedDate)
      })

      let {dayPartId} = this.state

      sessionStorage.setItem(
        'planParams',
        `planDateMin=${listData.planDateMin}&planDateMax=${
          listData.planDateMax
        }&sortBy=deliveryPlanDate_desc,deliveryPlanTimeFrom_asc,lastName_asc`
      )
      this.planAll(`${sessionStorage.getItem('planParams')}`, dayPartId)
      this.driverAll(`${sessionStorage.getItem('planParams')}`, dayPartId).then(() => {
        this.setState({
          excelDayPartId: dayPartId
        })
      })
      this.geoAll(`${sessionStorage.getItem('planParams')}`, dayPartId)
    }
  }

  reportDailyProductDriver() {
    if (this.state.selectedDate == null) {
      $('#date').addClass('errorInput')
      this.setState({
        errorPlans: 'یک تاریخ وارد کنید'
      })
    } else {
      let providerId = this.state.providerId

      this.setState({
        errorPlans: ''
      })
      $('#date').removeClass('errorInput')

      const listData = {
        planDateMin: this.epochFrom(this.state.selectedDate),
        planDateMax: this.epochTo(this.state.selectedDate)
      }
      JASPERREPORT(
        `report/jasper/dispatch/driver/supplier/products?fromTime=${listData.planDateMin}&toTime=${
          listData.planDateMax
        }&dayPartId=${this.state.dayPartId}&providerId=${providerId}`
      )
    }
  }

  reportDailyProductProvider() {
    if (this.state.selectedDate == null) {
      $('#date').addClass('errorInput')
      this.setState({
        errorPlans: 'یک تاریخ وارد کنید'
      })
    } else {
      let providerId = this.state.providerId

      this.setState({
        errorPlans: ''
      })
      $('#date').removeClass('errorInput')

      const listData = {
        planDateMin: this.epochFrom(this.state.selectedDate),
        planDateMax: this.epochTo(this.state.selectedDate)
      }
      JASPERREPORT(
        `report/jasper/dispatch/supplier/driver/products?fromTime=${listData.planDateMin}&toTime=${
          listData.planDateMax
        }&dayPartId=${this.state.dayPartId}&providerId=${providerId}`
      )
    }
  }
  date(props) {
    return <input className="form-control" {...props} />
  }

  submit(e) {
    e.preventDefault()
  }
  toggleConfirm = () => {
    this.setState({
      modalConfirm: !this.state.modalConfirm
    })
  }

  cancelConfirm = () => {
    this.setState({
      modalConfirm: !this.state.modalConfirm
    })
  }

  closeFinaly = () => {
    var listData = JSON.parse(sessionStorage.getItem('planTime'))
    var driverId = sessionStorage.getItem('driverId')
    let data = {
      driverId,
      from: listData.planDateMin,
      to: listData.planDateMax,
      checkFinished: false
    }
    this.setState({
      loading: true
    })

    http.post(`${RETAIL.RETAIL_MANAGE_DISPATCH_CLOSE}`, data, {}).then((response) => {
      // alert(JSON.stringify(response.data))
      this.setState({
        loading: false
      })
      if (response.data.error === null) {
        this.setState({
          loading: false
        })
        if (response.data.object) {
          this.setState(
            {
              loading: false,

              products:
                response.data.object.incompatibleProducts === null ? [] : response.data.object.incompatibleProducts,
              modalText: 'لیست کالاهای تحویل داده نشده رساننده',
              showProduct: true,
              showLacks: false,
              modalConfirm: !this.state.modalConfirm
            },
            () => {
              if (this.state.products.length > 0) {
                this.setState({
                  productModal: !this.state.productModal
                })
              }
            }
          )
          this.driverAll(
            `planDateMin=${listData.planDateMin}&planDateMax=${listData.planDateMax}&sortBy=lastName_asc`,
            3
          )
        } else {
          this.setState(
            {
              products: response.data.data,
              modalConfirm: !this.state.modalConfirm,
              modalIncompatibileProduct: true
            },
            () => {}
          )
        }
      } else {
        message.error(response.data.description)
      }
    })
  }

  openClose = (numId, finish, total) => {
    var closed = this.state.AssignedDrivers[numId].closed
    let driverId = this.state.AssignedDrivers[numId].driver.personId
    sessionStorage.setItem('driverId', driverId)
    var listData = JSON.parse(sessionStorage.getItem('planTime'))
    this.setState({
      products: [],
      unclosedParcels: []
    })
    if (closed) {
      let driverId = this.state.AssignedDrivers[numId].driver.personId
      let data = {
        driverId,
        from: listData.planDateMin,
        to: listData.planDateMax
      }
      this.setState({
        loading: true
      })
      http
        .post(`${RETAIL.RETAIL_MANAGE_DISPATCH_OPEN}`, data, {})
        .then((response) => {
          this.setState({
            loading: false
          })
          if (response.data.error == null) {
            this.driverAll(
              `planDateMin=${listData.planDateMin}&planDateMax=${listData.planDateMax}&sortBy=lastName_asc`,
              3
            )
          } else {
            message.error(response.data.description)
          }
        })
        .catch(() => {
          this.setState({
            loading: false
          })
        })
    } else {
      if (finish != total) {
        this.setState({
          modalConfirm: !this.state.modalConfirm
        })
        // this.cancelBtn.current.focus();
      } else {
        this.setState({
          loading: true
        })
        let driverId = this.state.AssignedDrivers[numId].driver.personId
        let data = {
          driverId,
          from: listData.planDateMin,
          to: listData.planDateMax,
          checkFinished: false
        }

        http
          .post(`${RETAIL.RETAIL_MANAGE_DISPATCH_CLOSE}`, data, {})
          .then((response) => {
            this.driverAll(
              `planDateMin=${listData.planDateMin}&planDateMax=${listData.planDateMax}&sortBy=lastName_asc`,
              3
            )
            this.setState({
              loading: false
            })
            if (response.data.error === null) {
              if (response.data.object) {
                this.setState(
                  {
                    loading: false,
                    products: response.data.object.incompatibleProducts,
                    modalText: 'لیست کالاهای تحویل داده نشده رساننده',
                    showProduct: true,
                    showLacks: false
                  },
                  () => {
                    if (this.state.products.length > 0) {
                      this.setState({
                        productModal: false
                      })
                    }
                  }
                )
              } else {
                this.setState(
                  {
                    products: response.data.data,
                    modalConfirm: false
                  },
                  () => {
                    if (this.state.products.length > 0) {
                      this.setState({
                        modalIncompatibileProduct: true
                      })
                    } else {
                      this.setState({
                        modalIncompatibileProduct: false
                      })
                    }
                  }
                )
              }
            } else {
              message.error(response.data.description)
              this.setState({
                loading: false
              })
            }
          })
          .catch(() => {
            this.setState({
              loading: false
            })
          })
      }
    }
  }

  toggleProduct = () => {
    this.setState({
      productModal: !this.state.productModal
    })
  }

  cancelProductModal = () => {
    this.setState({
      productModal: !this.state.productModal
    })
  }

  openConfirm = (numId, driverId) => {
    sessionStorage.setItem('driverId', driverId)
    this.setState({
      modalConfirmFinaly: !this.state.modalConfirmFinaly,
      check: false
    })
  }
  toggleConfirmFinaly = () => {
    this.setState({
      modalConfirmFinaly: !this.state.modalConfirmFinaly,
      check: false
    })
  }

  cancelConfirmFinaly = () => {
    this.setState({
      modalConfirmFinaly: !this.state.modalConfirmFinaly
    })
  }

  confirmFinaly = () => {
    var driverId = sessionStorage.getItem('driverId')

    var listData = JSON.parse(sessionStorage.getItem('planTime'))

    let data = {
      driverId,
      from: listData.planDateMin,
      to: listData.planDateMax
    }
    this.setState({
      loading: true
    })
    http.post(`${RETAIL.RETAIL_MANAGE_DISPATCH_DELIVERY_CONFIRM}`, data, {}).then((res) => {
      this.setState({
        loading: false,
        modalConfirmFinaly: false
      })
      if (res.data.error === null) {
        if (res.data.object) {
          if (res.data.object.dispatchIncompatibleDto.unMatch) {
            this.setState(
              {
                lacksProduct: res.data.object.dispatchIncompatibleDto.incompatibleProducts,
                modalText: 'لیست کالاهای مغایر',
                showProduct: false,
                showLacks: true,
                modalConfirmFinaly: false
              },
              () => {
                if (this.state.lacksProduct.length) {
                  this.setState({
                    productModal: true
                  })
                }
              }
            )
            this.driverAll(
              `planDateMin=${listData.planDateMin}&planDateMax=${listData.planDateMax}&sortBy=lastName_asc`,
              3
            )
          } else {
            if (res.data.object.unclosedParcels && res.data.object.unclosedParcels.length) {
              this.setState(
                {
                  modalConfirmFinaly: false,
                  modalText: 'مرسوله های بسته نشده',
                  unclosedParcels: res.data.object.unclosedParcels,
                  products: []
                },
                () => {
                  if (this.state.unclosedParcels.length) {
                    this.setState({
                      productModal: true,
                      showProduct: true,
                      showLacks: false
                    })
                  }
                }
              )
              this.driverAll(
                `planDateMin=${listData.planDateMin}&planDateMax=${listData.planDateMax}&sortBy=lastName_asc`,
                3
              )
            } else {
              this.driverAll(
                `planDateMin=${listData.planDateMin}&planDateMax=${listData.planDateMax}&sortBy=lastName_asc`,
                3
              )
            }
          }
        } else {
          if (Array.isArray(res.data.data)) {
            this.setState({
              unmatchProductDetailItems: res.data.data,
              unmatchProductDetailItemsModal: true
            })
          }
        }
      } else {
        this.setState({
          modalConfirmFinaly: false
        })
        this.driverAll(`planDateMin=${listData.planDateMin}&planDateMax=${listData.planDateMax}&sortBy=lastName_asc`, 3)
      }
    })
  }
  changeShift(e) {
    let dayPartId = e.target.value
    this.setState({
      dayPartId: Number(dayPartId)
    })
    //
    //
    // let listData=JSON.parse(sessionStorage.getItem('planTime'));
    // this.driverAll(`planDateMin=${listData.planDateMin}&planDateMax=${listData.planDateMax}`,dayPartId)
  }
  changeFieldConfirm(e) {
    const target = e.target
    const value = target.type == 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({
      [name]: value
    })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait; }',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)

    setTimeout(() => {
      window.print()
    }, 2000)
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
  }

  exportExcel = () => {
    if (sessionStorage.getItem('planParams')) {
      let params = sessionStorage.getItem('planParams')

      return http
        .get(
          `${REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_ALL}?export=true&${params}&dayPartId=${
            this.state.excelDayPartId
          }&sortBy=lastName_asc`,
          {}
        )
        .then((response) => {
          if (response.data.error == null) {
            let result = response.data.object.result.map((item) => ({
              ...item
            }))
            result.forEach((item) => {
              item.car =
                item.car.name +
                ' ' +
                'ایران' +
                item.car.plateNumber +
                ' - ' +
                ' (' +
                item.car.plateText +
                ') ' +
                'کد ماشین : ' +
                item.car.code
            })
            this.setState(
              {
                exportExcel: result
              },
              () => {
                this._export.save(this.state.exportExcel)
              }
            )
          } else {
          }
        })
        .catch((error) => {})
    } else {
      let getTimes = JSON.parse(sessionStorage.getItem('planTime'))
      let data = {
        planDateMin: getTimes.planDateMin,
        planDateMax: getTimes.planDateMax,
        export: true,
        dayPartId: this.state.excelDayPartId,
        sortBy: 'lastName_asc'
      }
      http
        .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DRIVER_ALL}`, {
          params: data
        })
        .then((response) => {
          if (response.data.error == null) {
            let result = response.data.object.result.map((item) => ({
              ...item
            }))
            result.forEach((item) => {
              item.car =
                item.car.name +
                ' ' +
                'ایران' +
                item.car.plateNumber +
                ' - ' +
                ' (' +
                item.car.plateText +
                ') ' +
                'کد ماشین : ' +
                item.car.code
            })
            this.setState(
              {
                exportExcel: result
              },
              () => {
                this._export.save(this.state.exportExcel)
              }
            )
          } else {
          }
        })
        .catch((error) => {})
    }

    // this.driverAll(`${sessionStorage.getItem('planParams')}`, this.state.excelDayPartId).then(res => {
    //     let result = res.result.map((item) => ({...item}))
    //     result.forEach(item => {
    //         item.car = item.car.name + ' ' + 'ایران' + item.car.plateNumber + ' - ' + ' (' + item.car.plateText + ') ' + 'کد ماشین : ' + item.car.code
    //     })
    //     this.setState({
    //         exportExcel: result
    //     }, () => {
    //         this._export.save(this.state.exportExcel)
    //     })
    // })
    // excelExport
  }

  render() {
    const {selectedDate, allPlans, planDateMin, planDateMax, dayPartId, selectedOption} = this.state

    return (
      <div className="body rtl">
        {!this.state.modalConfirm && !this.state.modalConfirmFinaly && <Loader show={this.state.loading} />}
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش رساننده های انتسابی.xls"
          >
            <grid style={{height: '420px'}} data={this.state.exportExcel}>
              <gridColumn
                key={'driver.personId'}
                field={'driver.personId'}
                title={'شناسه رساننده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'driver.name'}
                field={'driver.name'}
                title={'رساننده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'car'}
                field={'car'}
                title={'اتومبیل'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'totalCount'}
                field={'totalCount'}
                title={'تعداد کل'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'activeCount'}
                field={'activeCount'}
                title={'تعداد فعال'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'startCount'}
                field={'startCount'}
                title={'تعداد شروع شده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'inCount'}
                field={'inCount'}
                title={'تحویل در بازه'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'outCount'}
                field={'outCount'}
                title={'تحویل خارج بازه'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'finishCount'}
                field={'finishCount'}
                title={'تعداد تمام شده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'returnNotSeenCount'}
                field={'returnNotSeenCount'}
                title={'تعداد برگشتی'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'returnRejectCount'}
                field={'returnRejectCount'}
                title={'تعداد مرجوعی'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'returnReAssignCount'}
                field={'returnReAssignCount'}
                title={'تعداد تخصیص مجدد'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <thead>
              <tr>
                <td colSpan={12} className="centerHeader">
                  <h4>گزارش رساننده های انتصابی</h4>
                </td>
              </tr>
              <tr>
                <td colSpan={5} className="rightHeader">
                  <p style={{fontWeight: '600'}}>{'تاریخ بازه : ' + sessionStorage.getItem('selectDate')}</p>
                </td>
                <td colSpan={7} className="leftHeader">
                  <p style={{fontWeight: '600'}}>{'گزارش گیرنده :' + cookie.load('name')}</p>
                  <p style={{fontWeight: '600'}}>{'تاریخ گزارش :' + jMoment().format('jYY/jMM/jDD HH:mm')}</p>
                </td>
              </tr>
              <tr id="firstRowPrint">
                <td>
                  <span>ردیف</span>
                </td>
                <td>
                  <span>رساننده</span>
                </td>
                <td>
                  <span>شناسه</span>
                </td>
                <td>
                  <span>اتومبیل</span>
                </td>
                <td>
                  <span> تعداد کل</span>
                </td>
                <td>
                  <span> تعداد فعال</span>
                </td>

                <td>
                  <span> شروع شده</span>
                </td>
                <td>
                  <span> تحویل در بازه</span>
                </td>
                <td>
                  <span>تحویل خارج از بازه</span>
                </td>
                <td>
                  <span> تمام شده</span>
                </td>
                <td>
                  <span>بستن</span>
                </td>
                <td>
                  <span>تایید </span>
                </td>
              </tr>
            </thead>

            <tbody>
              {this.state.AssignedDrivers.map((drivers, index) => (
                <tr key={'i' + index} style={index % 2 == 0 ? {backgroundColor: '#f1f1f1'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{drivers.driver.name} </td>
                  <td>{drivers.driver.personId} </td>
                  <td>
                    {drivers.car.name +
                      ' ' +
                      'ایران' +
                      drivers.car.plateNumber +
                      ' - ' +
                      ' (' +
                      drivers.car.plateText +
                      ') ' +
                      'کد ماشین : ' +
                      drivers.car.code}
                  </td>
                  <td>{drivers.totalCount}</td>
                  <td>{drivers.activeCount}</td>
                  <td>{drivers.startCount}</td>
                  <td>{drivers.inCount}</td>
                  <td>{drivers.outCount}</td>
                  <td>{drivers.finishCount}</td>

                  <td>{drivers.closed ? 'بسته شده' : 'بسته نشده'}</td>

                  <td>{drivers.confirmed ? 'تایید شده' : 'تایید نشده'}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={4}>مجموع</td>
                <td>{this.state.aggregationAssigned.totalCount}</td>
                <td>{this.state.aggregationAssigned.activeCount}</td>
                <td>{this.state.aggregationAssigned.startCount}</td>
                <td>{this.state.aggregationAssigned.inCount}</td>
                <td>{this.state.aggregationAssigned.outCount}</td>
                <td>{this.state.aggregationAssigned.finishCount}</td>
                <td colSpan={2} />
              </tr>
            </tbody>
          </table>
        </div>

        <div className="wrapperIframe">
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>جست و جوی بازه های تحویل</p>
            </div>
            <div className="formComponent">
              <label>تاریخ :</label>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DatePicker
                  okLabel="تأیید"
                  autoOk={true}
                  leftArrowIcon={<Icon type="left" />}
                  rightArrowIcon={<Icon type="right" />}
                  cancelLabel="لغو"
                  labelFunc={(selectedDate) => (selectedDate == null ? '' : selectedDate.format('jYYYY/jM/jDD'))}
                  value={selectedDate}
                  id="date"
                  ref={(node) => (this.planDate = node)}
                  onChange={this.handleDateChange}
                  TextFieldComponent={this.date}
                  readOnly
                />
              </MuiPickersUtilsProvider>

              <label>شیفت زمانی : </label>
              <select className="form-control" id="shift" onChange={this.changeShift.bind(this)}>
                {this.state.shift.map((shift, index) => (
                  <option selected={shift.typeDayPartId == 3 ? true : false} value={shift.typeDayPartId}>
                    {shift.name}
                  </option>
                ))}
              </select>

              <AutoComplete
                label="تامین کننده"
                api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                textField="title"
                valueField="providerId"
                id="provider"
                value={this.state.providerId}
                setValue={(providerId) => this.setState({providerId})}
              />

              {/* <label>تامین کننده ها :</label>
              <Select
                value={selectedOption}
                onChange={this.handleChange}
                options={this.state.providers}
                isMulti={false}
                isClearable={true}
                id="providerId"
                placeholder=""
              /> */}

              <button className="btn setBtn resultPlans btn-block" onClick={this.searchPlanList.bind(this)}>
                نمایش نتایج
              </button>
              <button className="btn setBtn btn-block jasperBtn" onClick={this.reportDailyProductDriver.bind(this)}>
                گزارش کالای توزیع به تفکیک رساننده - تأمین کننده
              </button>
              <button className="btn setBtn btn-block jasperBtn" onClick={this.reportDailyProductProvider.bind(this)}>
                گزارش کالای توزیع به تفکیک تأمین کننده - رساننده
              </button>
              <p className="errorText">{this.state.errorPlans}</p>
              <p className="errorText" id="errorText" />
            </div>
          </form>

          <div style={allPlans.length == '0' ? {display: 'none'} : {display: 'block'}} className="tableComponent">
            <table className="baseTable">
              <tbody>
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>شیوه ارسال</td>
                  <td>تاریخ</td>
                  <td>بازه</td>
                  <td>تعداد کل</td>
                  <td>تعداد تخصیص نداده</td>
                  <td>تعداد فعال</td>
                  <td>تعداد شروع شده</td>
                  <td>تعداد تمام شده</td>
                  <td>تعداد برگشتی</td>
                  <td>تعداد مرجوعی</td>
                  <td>تعداد تخصیص مجدد</td>
                  <td>پارت تحویل</td>
                  <td>کالا ها</td>
                  <td>انتصاب رساننده</td>
                  <td>رساننده های انتصابی</td>
                </tr>
                {this.state.allPlans.map((items, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{items.deliveryMethodName}</td>
                    <td>{jMoment(items.planDate).format('jYYYY/jMM/jDD')}</td>
                    <td>
                      {items.planTimeFrom} الی {items.planTimeTo}
                    </td>
                    <td>{items.totalCount}</td>
                    <td>{items.notAssignedCount}</td>
                    <td>{items.activeCount}</td>
                    <td>{items.startCount}</td>
                    <td>{items.finishCount}</td>
                    <td>{items.returnNotSeenCount}</td>
                    <td>{items.returnRejectCount}</td>
                    <td>{items.returnReAssignCount}</td>
                    <td>
                      <Link to={`/Factors?planId=${items.planId}&planDate=${items.planDate}`}>
                        <img src={require('../../image/editDriver.svg')} alt="" />
                      </Link>
                    </td>

                    <td>
                      <Link
                        to={`/productPlan/${items.planId}/${items.planDate}/${items.planTimeFrom}/${items.planTimeTo}`}
                      >
                        <img src={require('../../image/product.svg')} alt="" />
                      </Link>
                    </td>

                    <td>
                      <Link to={`SetDrivers/${items.planId}`}>
                        <img
                          src={require('../../image/driver.svg')}
                          style={
                            items.totalCount -
                              (items.activeCount +
                                items.startCount +
                                items.finishCount +
                                items.returnNotSeenCount +
                                items.returnRejectCount) <=
                            0
                              ? {display: 'none'}
                              : {display: 'inline-block'}
                          }
                          alt=""
                        />
                      </Link>
                    </td>

                    <td>
                      <Link
                        to={`AssignedDrivers/${items.planId}/${items.planDate}/${items.planTimeFrom}/${
                          items.planTimeTo
                        }`}
                      >
                        <img
                          style={
                            items.totalCount ===
                            items.totalCount -
                              (items.activeCount +
                                items.startCount +
                                items.finishCount +
                                items.returnNotSeenCount +
                                items.returnRejectCount)
                              ? {display: 'none'}
                              : {display: 'inline-block'}
                          }
                          src={require('../../image/delivery-truck.svg')}
                          alt=""
                        />
                      </Link>
                    </td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={4}>مجموع</td>
                  <td>{this.state.aggregationPlan.totalCount}</td>
                  <td>{this.state.aggregationPlan.notAssignedCount}</td>
                  <td>{this.state.aggregationPlan.activeCount}</td>
                  <td>{this.state.aggregationPlan.startCount}</td>
                  <td>{this.state.aggregationPlan.finishCount}</td>
                  <td>{this.state.aggregationPlan.returnNotSeenCount}</td>
                  <td>{this.state.aggregationPlan.returnRejectCount}</td>
                  <td>{this.state.aggregationPlan.returnReAssignCount}</td>
                  <td colSpan={4} />
                </tr>
              </tbody>
            </table>
          </div>

          {this.state.AssignedDrivers.length > 0 && (
            <div className="tableComponent assignTable">
              <p
                style={{
                  fontWeight: '600',
                  textAlign: 'center',
                  paddingTop: '20px',
                  fontSize: '1.3em'
                }}
              >
                رساننده های انتصابی
              </p>
              <div>
                <button className="printButton" onClick={this.exportPrint}>
                  چاپ
                </button>
                <button className="printButton" onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
              </div>
              <table
                className="baseTable"
                style={
                  this.state.AssignedDrivers.length == '0'
                    ? {display: 'none', marginTop: '15px'}
                    : {display: 'block', marginTop: '15px'}
                }
              >
                <tbody>
                  <tr className="firstRow">
                    <td>
                      <span>ردیف</span>
                    </td>
                    <td>
                      <span>رساننده</span>
                    </td>
                    <td>
                      <span>شناسه</span>
                    </td>

                    <td>
                      <span>اتوموبیل</span>
                    </td>
                    <td>
                      <span>تعداد کل</span>
                    </td>
                    <td>
                      <span>تعداد فعال</span>
                    </td>
                    <td>
                      <span>تعداد شروع شده</span>
                    </td>
                    <td>
                      <span> تحویل در بازه</span>
                    </td>
                    <td>
                      <span>تحویل خارج از بازه</span>
                    </td>
                    <td>
                      <span>تعداد تمام شده</span>
                    </td>

                    <td>
                      <span>تعداد برگشتی</span>
                    </td>
                    <td>
                      <span>تعداد مرجوعی</span>
                    </td>
                    <td>
                      <span>تعداد تخصیص مجدد</span>
                    </td>
                    <td>
                      <span>فاکتور ها</span>
                    </td>
                    <td>
                      <span>کالا ها</span>
                    </td>
                    <td>
                      <span>مانده رساننده</span>
                    </td>
                    <td>
                      <span>آخرین مسیر </span>
                    </td>
                    <td>
                      <span>بستن</span>
                    </td>
                    <td>
                      <span>تایید </span>
                    </td>
                  </tr>
                  {this.state.AssignedDrivers.map((drivers, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{drivers.driver.name} </td>
                      <td>{drivers.driver.personId} </td>
                      <td>
                        {drivers.car.name +
                          ' ' +
                          'ایران' +
                          drivers.car.plateNumber +
                          ' - ' +
                          ' (' +
                          drivers.car.plateText +
                          ') ' +
                          'کد ماشین : ' +
                          drivers.car.code}
                      </td>
                      <td>{drivers.totalCount}</td>
                      <td>{drivers.activeCount}</td>
                      <td>{drivers.startCount}</td>
                      <td>{drivers.inCount}</td>
                      <td>{drivers.outCount}</td>
                      <td>{drivers.finishCount}</td>
                      <td>{drivers.returnNotSeenCount}</td>
                      <td>{drivers.returnRejectCount}</td>
                      <td>{drivers.returnReAssignCount}</td>

                      <td>
                        {/*<Link target='_blank'  to={`/DriverBasket/${drivers.driver.personId}/${planDateMin}/${planDateMax}/${drivers.driver.name}/${dayPartId}`}>*/}
                        {/*    <img src={require('../../image/editDriver.svg')} alt=""/>*/}
                        {/*</Link>*/}
                        <Link
                          target="_blank"
                          to={`/DriverBasket?driverId=${
                            drivers.driver.personId
                          }&planDateMin=${planDateMin}&planDateMax=${planDateMax}&driverName=${
                            drivers.driver.name
                          }&dayPartId=${dayPartId}`}
                        >
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </Link>
                      </td>

                      <td>
                        <Link
                          target="_blank"
                          to={`/ProductDriver/${drivers.driver.personId}/${planDateMin}/${planDateMax}/${
                            drivers.driver.name
                          }/${dayPartId}`}
                        >
                          <img src={require('../../image/product.svg')} alt="" />
                        </Link>
                      </td>

                      <td>
                        <Link
                          target="_blank"
                          to={`/RemainDriver/${drivers.driver.personId}/${planDateMin}/${planDateMax}/${
                            drivers.driver.name
                          }/${dayPartId}`}
                        >
                          <img src={require('../../image/money.svg')} alt="" />
                        </Link>
                      </td>

                      <td>
                        <Link
                          target="_blank"
                          to={`/LastRouteDriver/${drivers.driver.personId}/${drivers.driver.name}/${dayPartId}`}
                        >
                          <img src={require('../../image/liveRoute.svg')} alt="" />
                        </Link>
                      </td>

                      <td>
                        <button
                          style={drivers.confirmed ? {display: 'none'} : {display: 'inline-block'}}
                          onClick={() => this.openClose(index, drivers.finishCount, drivers.totalCount)}
                        >
                          {drivers.closed ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>

                      <td>
                        <button
                          disabled={drivers.confirmed ? true : false}
                          onClick={() => this.openConfirm(index, drivers.driver.personId, drivers.confirmed)}
                        >
                          {drivers.confirmed ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                    </tr>
                  ))}

                  <tr>
                    <td colSpan={4}>مجموع</td>
                    <td>{this.state.aggregationAssigned.totalCount}</td>
                    <td>{this.state.aggregationAssigned.activeCount}</td>
                    <td>{this.state.aggregationAssigned.startCount}</td>

                    <td>{this.state.aggregationAssigned.inCount}</td>
                    <td>{this.state.aggregationAssigned.outCount}</td>

                    <td>{this.state.aggregationAssigned.finishCount}</td>
                    <td>{this.state.aggregationAssigned.returnNotSeenCount}</td>
                    <td>{this.state.aggregationAssigned.returnRejectCount}</td>
                    <td>{this.state.aggregationAssigned.returnReAssignCount}</td>
                    <td colSpan={4} />
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          <Modal isOpen={this.state.productModal} toggle={this.toggleProduct}>
            <ModalHeader toggle={this.toggleProduct}>{this.state.modalText}</ModalHeader>
            <ModalBody>
              <Loader show={this.state.loading} />
              <div style={this.state.showLacks ? {display: 'block'} : {display: 'none'}}>
                <table className="baseTable">
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام محصول</td>
                    <td>مانده</td>
                    <td>درخواست شده</td>
                  </tr>
                  {this.state.lacksProduct.map((pro, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{pro.title}</td>
                      <td>{pro.remainQuantity}</td>
                      <td>{pro.requestedQuantity}</td>
                    </tr>
                  ))}
                </table>
              </div>
              <div style={this.state.showProduct ? {display: 'block'} : {display: 'none'}}>
                {this.state.products.length > 0 && (
                  <table className="baseTable">
                    <tr className="firstRow">
                      <td>ردیف</td>
                      <td>نام محصول</td>
                      <td>مانده</td>
                    </tr>
                    {this.state.products.map((pro, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{pro.title}</td>
                        <td>{pro.remainQuantity}</td>
                      </tr>
                    ))}
                  </table>
                )}
                {this.state.unclosedParcels.length > 0 && (
                  <div className="mt-2">
                    <h4 className="font-weight-bold text-center">مرسوله های بسته نشده در {APP.name}</h4>
                    <table className="baseTable">
                      <tr className="firstRow">
                        <td>ردیف</td>
                        <td>نام محصول</td>
                        <td>شناسه سفارش</td>
                        <td>پیغام</td>
                      </tr>
                      {this.state.unclosedParcels.map((item, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{item.productTitle}</td>
                          <td>{item.orderId}</td>
                          <td>
                            {item.type === 'PAYMENT' && `مرسوله ${item.parcelId} تسویه نشده است`}
                            {item.type === 'WEIGHT' && `یک یا چند آیتم مرسوله ${item.parcelId} وزن کشی نشده است`}
                            {item.type === 'PRICE' && `قیمت یک یا چند مرسوله ${item.parcelId} نهایی نشده است`}
                            {item.type === 'INVENTORY' &&
                              `پردازش انبار برخی از اقلام مرسوله ${item.parcelId} هنوز انجام نشده است`}
                            {item.type === 'ORDER_ALREADY_DONE' && `سفارش ${item.orderId} انجام شده است`}
                          </td>
                        </tr>
                      ))}
                    </table>
                  </div>
                )}
              </div>
            </ModalBody>
            <ModalFooter>
              <button className="cancelBtnModal" onClick={this.cancelProductModal}>
                بستن
              </button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={this.state.modalConfirm} toggle={this.toggleConfirm.bind(this)} size="sm">
            <ModalHeader toggle={this.toggleConfirm.bind(this)}>تاییدیه</ModalHeader>
            <ModalBody>
              <Loader show={this.state.loading} />
              <p className="titleSm">هنوز تمامی سفارشات به مقصد نرسیده است..آیا از انجام عملیات مطمئن هستید؟؟</p>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.closeFinaly.bind(this)}>
                بستن سفارش
              </button>

              <button
                className="cancelBtnModal"
                ref={this.cancelBtn}
                id="cancelBtn"
                onClick={this.cancelConfirm.bind(this)}
              >
                لغو
              </button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={this.state.modalConfirmFinaly} toggle={this.toggleConfirmFinaly.bind(this)} size="sm">
            <ModalHeader toggle={this.toggleConfirmFinaly.bind(this)}>تاییدیه</ModalHeader>
            <ModalBody>
              <Loader show={this.state.loading} />
              <p className="titleSm">
                <Checkbox name="check" tabIndex="4" onChange={this.changeFieldConfirm.bind(this)}>
                  آیا از انجام عملیات مطمئن هستید؟
                </Checkbox>
              </p>
            </ModalBody>
            <ModalFooter>
              <button
                className="confirmBtnModal"
                disabled={this.state.check ? false : true}
                onClick={this.confirmFinaly.bind(this)}
              >
                تایید سفارش
              </button>

              <button className="cancelBtnModal" id="cancelBtn" onClick={this.cancelConfirmFinaly.bind(this)}>
                لغو
              </button>
            </ModalFooter>
          </Modal>

          <Modal
            isOpen={this.state.modalIncompatibileProduct}
            toggle={() => this.setState({modalIncompatibileProduct: false})}
          >
            <ModalBody>
              <h4 className="font-weight-bold text-center">مغایرت کالاهای فاکتور و کالاهای تحویل داده شده</h4>
              <table className="baseTable">
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>نام محصول</td>
                  <td>شناسه فاکتور</td>
                  <td>تعداد در فاکتور</td>
                  <td>تعداد تحویل داده شده</td>
                </tr>
                {this.state.products.map((item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{item.productName}</td>
                    <td>
                      <a target="_blank" href={editOrder({invoiceId: item.invoiceId})}>
                        {item.invoiceId}
                      </a>
                    </td>
                    <td>{item.invoiceQuantity}</td>
                    <td>{item.deliveredQuantity}</td>
                  </tr>
                ))}
              </table>
            </ModalBody>
            <ModalFooter>
              <button
                className="cancelBtnModal"
                id="cancelBtn"
                onClick={() => this.setState({modalIncompatibileProduct: false})}
              >
                انصراف
              </button>
            </ModalFooter>
          </Modal>

          <Modal
            isOpen={this.state.modalIncompatibileProduct}
            toggle={() => this.setState({modalIncompatibileProduct: false})}
          >
            <ModalBody>
              <h4 className="font-weight-bold text-center">مغایرت کالاهای فاکتور و کالاهای تحویل داده شده</h4>
              <table className="baseTable">
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>نام محصول</td>
                  <td>شناسه فاکتور</td>
                  <td>تعداد در فاکتور</td>
                  <td>تعداد تحویل داده شده</td>
                </tr>
                {this.state.products.map((item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{item.productName}</td>
                    <td>
                      <a target="_blank" href={editOrder({invoiceId: item.invoiceId})}>
                        {item.invoiceId}
                      </a>
                    </td>
                    <td>{item.invoiceQuantity}</td>
                    <td>{item.deliveredQuantity}</td>
                  </tr>
                ))}
              </table>
            </ModalBody>
            <ModalFooter>
              <button
                className="cancelBtnModal"
                id="cancelBtn"
                onClick={() => this.setState({modalIncompatibileProduct: false})}
              >
                انصراف
              </button>
            </ModalFooter>
          </Modal>

          <Modal
            isOpen={this.state.unmatchProductDetailItemsModal}
            toggle={() => this.setState({unmatchProductDetailItemsModal: false})}
            size="md"
          >
            <ModalBody>
              <h5 className="font-weight-bold text-center">مغایرت کالاهای تحویل داده شده / نشده توسط رساننده</h5>
              <table className="baseTable">
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>شناسه فاکتور</td>
                  <td>مرسوله</td>
                  {/* <td>شناسه محصول در فاکتور</td> */}
                  <td>توضیحات</td>
                </tr>
                {this.state.unmatchProductDetailItems.map((item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{item.invoiceId}</td>
                    <td>{item.deliveryPackId}</td>
                    <td>
                      {item.dispatchDetailItemNotFound && `کالای ${item.productName} توسط رساننده تحویل داده نشده است`}
                      {item.parcelItemNotFound && `کالای ${item.productName} در سفارش وجود ندارد`}
                      {item.deliveredQuantity &&
                        item.orderItemQuantity &&
                        `مقدار تحویل شده کالای ${item.productName} با مقدار درج شده در سفارش مغایر است`}
                    </td>
                  </tr>
                ))}
              </table>
            </ModalBody>
            <ModalFooter>
              <button
                className="cancelBtnModal"
                id="cancelBtn"
                onClick={() => this.setState({unmatchProductDetailItemsModal: false})}
              >
                انصراف
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default Search
